import * as React from "react";
import { Routes, Route } from "react-router-dom";
import Dashboard from "./AdminPage/pages/Dashboard";
import {
  ViewUser,
  SingleUser,
  UserTransaction,
  UpdateUser,
  Login,
  Signup,
  Settings,
  ViewComment,
  CreateBlogs,
  ViewBlogs,
  UpdateBlogs,
  CreateTeams,
  UpdateTeams,
  ViewTeams,
  CreateTestimonial,
  UpdateTestimonial,
  ViewTestimonial,
  CreatePartners,
  ViewPartners,
  UpdatePartner,
  Appointment,
} from "./AdminPage/pages";
import ProtectedRoutes from "./AdminPage/pages/protectedRoutes/ProtectedRoutes";
import Page404 from "./AdminPage/pages/page404/page404";
// Landing page

function App() {
  var hours = 1; // Clears localStorage after 1 hour
  var now = new Date().getTime();
  var setupTime = Number(localStorage.getItem("setupTime")); // Convert to number

  if (!setupTime) {
    localStorage.setItem("setupTime", now);
  } else {
    if (now - setupTime > hours * 60 * 60 * 1000) {
      localStorage.clear();
      localStorage.setItem("setupTime", now);
    }
  }

  return (
    <>
      {/* Routes */}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route element={<ProtectedRoutes />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/dashboard" element={<Dashboard />} />

          <Route path="/single-user/:id" element={<SingleUser />} />
          <Route path="/customers" element={<ViewUser />} />
          <Route path="/updateUser/:id" element={<UpdateUser />} />
          <Route path="/user-transaction" element={<UserTransaction />} />

          <Route path="/messages" element={<ViewComment />} />
          <Route path="/show-appointments" element={<Appointment />} />
          <Route path="/setting" element={<Settings />} />

          <Route path="/add-news" element={<CreateBlogs />} />
          <Route path="/all-news" element={<ViewBlogs />} />
          <Route path="/update-news/:id" element={<UpdateBlogs />} />

          <Route path="/add-teams" element={<CreateTeams />} />
          <Route path="/all-teams" element={<ViewTeams />} />
          <Route path="/update-teams/:id" element={<UpdateTeams />} />

          <Route path="/add-partners" element={<CreatePartners />} />
          <Route path="/all-partners" element={<ViewPartners />} />
          <Route path="/update-partners/:id" element={<UpdatePartner />} />

          <Route path="/add-testimonials" element={<CreateTestimonial />} />
          <Route path="/all-testimonials" element={<ViewTestimonial />} />
          <Route
            path="/update-testimonials/:id"
            element={<UpdateTestimonial />}
          />
        </Route>
        <Route path="*" element={<Page404 />} />
      </Routes>
    </>
  );
}

export default App;
